import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Layout, Users } from 'lucide-react';
const services = [{
  title: 'Brand Consulting',
  description: 'I help you create organic ways to engage with your audiences. From defining your voice to crafting authentic touchpoints, we build the foundation for meaningful connections that drive brand awareness.',
  icon: Sparkles
}, {
  title: 'User Experience Design',
  description: 'I help you build your tech platform and user workflow in a way that is simple and increases user stickiness. Every interaction is designed to keep users engaged and coming back.',
  icon: Layout
}, {
  title: 'Content Direction',
  description: 'I teach you strategies on how to build communities around your brand and within your platform. Learn how to create content that sparks conversation and turns followers into advocates.',
  icon: Users
}];
export function Services() {
  return <section id="services" className="px-6 py-24 bg-[#F5F0F3]" data-id="element-158">
      <div className="max-w-7xl mx-auto" data-id="element-159">
        <motion.div className="mb-16 md:mb-24 max-w-3xl" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-160">
          <h2 className="text-4xl md:text-5xl font-serif mb-6 text-[#4A3B47]" data-id="element-161">
            How I Help You Grow
          </h2>
          <p className="text-lg text-[#4A3B47]/70 leading-relaxed" data-id="element-162">
            I create communities that increase your engagement and brand
            awareness. This is a holistic approach that starts with building
            your platform from scratch and the targeted audience around it.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-16" data-id="element-163">
          {services.map((service, index) => <motion.div key={service.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="group" data-id="element-164">
              <div className="w-12 h-12 mb-6 rounded-full bg-[#A88B9D]/15 flex items-center justify-center text-[#A88B9D] group-hover:bg-[#A88B9D] group-hover:text-white transition-colors duration-300" data-id="element-165">
                <service.icon className="w-6 h-6" data-id="element-166" />
              </div>
              <h3 className="text-2xl font-serif mb-4 text-[#4A3B47]" data-id="element-167">
                {service.title}
              </h3>
              <p className="text-[#4A3B47]/70 leading-relaxed" data-id="element-168">
                {service.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}